import { Box } from '@zillow/constellation';
import React from 'react';

const SidebarWrapper = ({ children, sticky = false }) => (
    <Box
        sx={{
            ...(sticky
                ? {
                      position: 'sticky',
                      top: '$spacing.md',
                      alignSelf: 'flex-start',
                  }
                : {}),
        }}
    >
        {children}
    </Box>
);

const MasterLayout = ({
    children,
    contentWidth = '$breakpoints.xl',
    sidebar,
    stickySidebar,
    gapSpacing = '$spacing.xl',
    footer,
    hasTags,
    hero,
    relatedArticles,
}) => (
    <React.Fragment>
        <Box
            sx={{
                margin: '0 auto',
                maxWidth: contentWidth,
                // If has tags, reduce the bottom spacing, otherwise it makes
                // the authoriship component look too far from "Related Articles".
                padding: hasTags
                    ? '$spacing.xl $spacing.sm'
                    : '$spacing.xl $spacing.sm $spacing.md $spacing.sm',
                '@media $md': {
                    padding: '$spacing.xl $spacing.sm',
                },
            }}
        >
            {hero && (
                <Box
                    sx={{
                        marginBottom: '$spacing.xs',
                        // Tablet is md and lg
                        '@media $md': {
                            marginBottom: '$spacing.md',
                        },
                        // Desktop is xl+
                        '@media $xl': {
                            marginBottom: '$spacing.xl',
                        },
                    }}
                >
                    {hero}
                </Box>
            )}

            <Box
                sx={{
                    '@media $lg': {
                        display: 'flex',
                    },
                }}
            >
                <Box
                    sx={{
                        flex: '1 1 0',
                        minWidth: 0,
                        // On mobile, when no tags, add some spacing otherwise
                        // the authorship component is too close to post content.
                        marginBottom: hasTags ? 0 : '$spacing.lg',
                        '@media $md': {
                            marginBottom: 0,
                        },
                    }}
                >
                    {children}
                </Box>
                {(sidebar || stickySidebar) && (
                    <Box
                        sx={{
                            marginTop: '$spacing.xl',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            width: '300px',
                            '@media $md_lte': {
                                width: '100%',
                                marginTop: 0,
                            },
                            '@media $lg': {
                                marginLeft: gapSpacing,
                                marginRight: 0,
                                marginTop: 0,
                            },
                        }}
                    >
                        {sidebar && <SidebarWrapper>{sidebar}</SidebarWrapper>}
                        {stickySidebar && (
                            <SidebarWrapper sticky>
                                {stickySidebar}
                            </SidebarWrapper>
                        )}
                    </Box>
                )}
            </Box>
        </Box>

        {(footer || relatedArticles) && (
            <Box
                sx={{
                    margin: '0 auto',
                    padding: '0',
                    maxWidth: '$breakpoints.xxl',

                    '@media $md': {
                        padding: '0 $spacing.sm',
                    },
                }}
            >
                {relatedArticles}

                <Box
                    sx={{
                        padding: '0 0 $spacing.xl',
                        '@media $sm_lte': {
                            padding: '0 $spacing.sm $spacing.xl',
                        },
                    }}
                >
                    {footer}
                </Box>
            </Box>
        )}
    </React.Fragment>
);

export default MasterLayout;
